var ResponsiveUtils = require('./responsiveUtils');

/**
 * Calculate the font size for the header text which can fit into the max-width
 * 
 * @param {*} $header actual header element
 * @param {*} $span the span element used for font size calc
 * @param {*} maxWidth max width of the container
 * @param {*} minFontSize min font size to which it can drop down to
 */
function estimateFontSize($header, $span, maxWidth, minFontSize) {
    var fontSize = parseInt($header.css('font-size'));

    do {
      fontSize = fontSize - 4;
      $span.css('font-size', fontSize);
    } while( $span.width() > maxWidth && fontSize > minFontSize );
    return Math.max(fontSize, minFontSize);
}

/**
 * Font Re-Size Utility. Calculate and set the font size based on the max-width and min-font-size
 * 
 * @param {*} $el JQuery Element of the Parent Node  
 * @param {*} txtSel the text element selector
 * @param {*} minFontSize Min Font Size untill it can fall down to
 */
function fontResizer($el, txtSel, minFontSize) {
    var $header = $el.find(txtSel);
    var $span = $('<span></span>');
    $span.hide().css('font-family', $header.css('font-family')).text(_.trim($header.text()));
    $el.append($span);

    function reSizeHeader() {
        var containerWidth = window.outerWidth || $(window).width();
        $header.css('font-size', '');
        if( containerWidth < 1024 || $header.hasClass('no-resize') ) {
          return;      
        }
        
        var headerWidth = $header.width();
        var maxWidth = $el.width() - (parseInt($header.css('padding-left')) + 32);
    
        if( headerWidth > maxWidth ) {
          $header.css('font-size', estimateFontSize($header, $span, maxWidth, minFontSize));
        }
    }

    if(document.fonts && document.fonts.ready) {
        document.fonts.ready.then(reSizeHeader);
    } else {
        reSizeHeader();
    }

    var responsiveUtils = ResponsiveUtils.create({
        orientationChangeEventHandler: reSizeHeader,
        resizeEventHandler: reSizeHeader
    });

    responsiveUtils.init();  
}

module.exports = fontResizer;